import { RequestError } from '../requestError';
import api from '../axiosBase';
import { getURL } from '../serviceHelper';
import { getEnv } from '../../AppConfigs';

const SPSiteId = getEnv('REACT_APP_SP_SITE_ID');
const SPListId = getEnv('REACT_APP_DOCUMENT_CONTENTS_LINK_LIST_ID');
const expand = 'expand=fields(select=id, docId, docCode, Title, docLinkPosition, Content, ContentId, ContentLastModified, docTypeId, docLinkId, docLinkTitle, docLinkCode, docLinkType)';

export class DocumentContentLinkService {
  static async getListContentLink() {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=5000`))
      .then(res => res.data.value && res.data.value.map((o: any) => ({ ...o.fields })))
      .catch(err => { throw new RequestError(err) });
  }

  static async addContentLink(fields: any) {
    return api.post(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items`), fields)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async updateContentLink(id: any, fields: any) {
    return api.patch(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/fields`), fields)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }
}
